export const checkIsCoubicApp = (coubicUAType?: string, user_agent?: string) =>
  coubicUAType === 'coubook-ios' ||
  coubicUAType === 'coubook-android' ||
  ((user_agent?.includes('stores_reserve_end_user_app') ||
    user_agent?.includes('stores_reserve_owner_app')) ??
    false);
